(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/navigation-menu/assets/javascripts/navigation-user.js') >= 0) return;  svs.modules.push('/components/components/navigation-menu/assets/javascripts/navigation-user.js'); 
var svs = svs || {};

(function(svs) {
  'use strict';

  svs.components = svs.components || {};
  svs.components.Navigation = svs.components.Navigation || {};


  svs.components.Navigation.User = function() {
    var userMenuOpen = false,
      $sessionTimeContainer = $(
        '.js-session-time .nav-list-item-link-title, .js-session-time .nav-list-item-text-title'
      ),
      $lastLoginTimeContainer = $(
        '.js-last-login-time .nav-list-item-link-title, .js-last-login-time .nav-list-item-text-title'
      ),
      $sessionTimeContainerAccountBalanceBar = $(
        '.js-session-time-account-balance-bar'
      );
    function init() {
      renderLoggedInTime(svs.components.session_time.get());
      renderLastLoginTime();
      setupListeners();
    }

    function setupListeners() {
      $('.js-nav-list-item-login .nav-list-item-link').on('click', function(e) {
        if (svs.core.userSession.isAnonymous()) {
          svs.components.customer_login.login();
          e.preventDefault();
          return false;
        }
      });

      $('.js-nav-list-item-link-user').on('click', function() {
        svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) &&
          !userMenuOpen &&
          getAccountBalance();
        userMenuOpen = !userMenuOpen;
      });
      $(document).on('click', '.js-account-logout', logout);

      svs.components.account_balance.on('change', renderAccountBalance);
      svs.events.subscribe(
        '/components/session_time/sessionTimeM',
        renderLoggedInTime
      );
    }

    function getAccountBalance() {
      if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
        svs.components.account_balance.get(true, renderAccountBalance);
      } else {
        renderAccountBalance();
      }
    }

    function renderLastLoginTime() {
      if (
        svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) &&
        $lastLoginTimeContainer.length > 0
      ) {
        var updateLastLoginTime = function(lastLoginTime, err) {
            if (err || lastLoginTime === undefined || lastLoginTime === '') {
              lastLoginTime = formatDate(new Date(), false);
              svs.core.userSession.set('lastLoginTime', lastLoginTime);
            }
            $lastLoginTimeContainer.html(
              'Senaste inloggning<br>' + lastLoginTime
            );
            return lastLoginTime;
          },
          formatDate = function(inDate, withSeconds) {
            var zeroPad = function(n) {
              return n < 10 ? '0' + n : n;
            };
            try {
              return (
                inDate.getFullYear() +
                '-' +
                zeroPad(inDate.getMonth() + 1) +
                '-' +
                zeroPad(inDate.getDate()) +
                ' ' +
                zeroPad(inDate.getHours()) +
                ':' +
                zeroPad(inDate.getMinutes()) +
                (withSeconds ? ':' + zeroPad(inDate.getSeconds()) : '')
              );
            } catch (e) {
              return '';
            }
          };
        svs.core.userSession.get('lastLoginTime', function(error, data) {
          if (!error) {
            updateLastLoginTime(data);
          }
        });
      }
    }

    function renderLoggedInTime(timesInMinutes) {
      var timeToDisplay = '00:00';
      function getMinString(minutes) {
        return minutes < 10 ? '0' + minutes : minutes;
      }
      if (timesInMinutes < 10 * 60) {
        timeToDisplay =
          '0' +
          Math.floor(timesInMinutes / 60) +
          ':' +
          getMinString(timesInMinutes % 60);
      } else if (timesInMinutes < 24 * 60) {
        timeToDisplay =
          Math.floor(timesInMinutes / 60) +
          ':' +
          getMinString(timesInMinutes % 60);
      } else if (timesInMinutes < 48 * 60) {
        timeToDisplay = '1 dag';
      } else {
        timeToDisplay = Math.ceil(timesInMinutes / (24 * 60)) + ' dagar';
      }
      $sessionTimeContainer.html('Inloggad tid ' + timeToDisplay);
      $sessionTimeContainerAccountBalanceBar.length > 0 &&
        $sessionTimeContainerAccountBalanceBar.html(
          'Inloggad tid: <span class="f-bold">' + timeToDisplay + '</span>'
        );
    }
    function renderAccountBalance(balance) {
      var $container = $('.js-account-balance'),
        $title = $container.find(
          '.nav-list-item-link-title, .nav-list-item-text-title'
        );

      $title.html(
        '<span class="f-bold">' +
          svs.utils.format.Currency(balance) +
          '</span><span class="f-normal"> kr</span>'
      );
    }
    function logout(e) {
      e.preventDefault();

      var evt = { category: 'Users', action: 'Logout' };
      svs.components.analytics.trackEvent(evt);
      svs.core.userSession.logout();
    }

    init();
  };
  new svs.components.Navigation.User();
})(svs);

 })(window);